"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _lodash2 = _interopRequireDefault(require("lodash.isundefined"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _CloseIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseIcon"));
var _ArrowDownSolidIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ArrowDownSolidIcon"));
var _CalendarIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/CalendarIcon"));
var _StyledDateTimeSelectorInput = require("../styled/StyledDateTimeSelectorInput");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DateTimeRangeSelectorInput = function DateTimeRangeSelectorInput(_ref) {
  var hasError = _ref.hasError,
    IconLeft = _ref.iconLeft,
    id = _ref.id,
    inputIcon = _ref.inputIcon,
    isOpen = _ref.isOpen,
    size = _ref.size,
    isClearable = _ref.isClearable,
    isDisabled = _ref.isDisabled,
    isValueSelected = _ref.isValueSelected,
    onClear = _ref.onClear,
    onClick = _ref.onClick,
    title = _ref.title,
    theme = _ref.theme,
    popperAnchorRef = _ref.popperAnchorRef,
    setInputRef = _ref.setInputRef,
    testId = _ref.testId;
  var iconColor = theme.iconColor,
    placeholderColor = theme.placeholderColor,
    isClassic = theme.isClassic;
  var setRef = function setRef(node) {
    popperAnchorRef(node);
    setInputRef(node);
  };
  var getInputIcon = function getInputIcon() {
    var iconProps = _objectSpread(_objectSpread({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ICON"))), {}, {
      isDisabled: isDisabled,
      color: iconColor,
      reverse: isOpen
    });
    if ((0, _lodash2["default"])(inputIcon)) {
      return /*#__PURE__*/_react["default"].createElement(_StyledDateTimeSelectorInput.InputIcon, _extends({}, iconProps, {
        as: isClassic ? _ArrowDownSolidIcon["default"] : _CalendarIcon["default"]
      }));
    }
    if (typeof inputIcon === 'function') {
      var Icon = inputIcon;
      return /*#__PURE__*/_react["default"].createElement(Icon, iconProps);
    }
    return inputIcon;
  };
  var handleOnClear = function handleOnClear(e) {
    e.stopPropagation();
    onClear();
  };
  return /*#__PURE__*/_react["default"].createElement(_StyledDateTimeSelectorInput.InputContainer, _extends({
    "aria-disabled": isDisabled,
    "aria-invalid": hasError,
    hasError: hasError,
    id: id
  }, (0, _oxygenConfig.getTestAttributes)(testId), {
    isOpen: isOpen,
    isClearable: isClearable,
    isDisabled: isDisabled,
    size: size,
    onClick: onClick,
    ref: setRef,
    title: title,
    isPlaceholder: !isValueSelected
  }), IconLeft && /*#__PURE__*/_react["default"].createElement(_StyledDateTimeSelectorInput.InputIconLeft, null, /*#__PURE__*/_react["default"].createElement(IconLeft, {
    isDisabled: isDisabled,
    color: isValueSelected ? iconColor : placeholderColor
  })), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeSelectorInput.InputTitle, null, title), isClearable && !isOpen && isValueSelected && /*#__PURE__*/_react["default"].createElement(_CloseIcon["default"], _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CLEAR_ICON")), {
    theme: {
      linkColor: theme.clearIconColor,
      hoverColor: theme.clearIconHoverColor
    },
    link: true,
    isOpen: isOpen,
    onClick: handleOnClear
  })), getInputIcon());
};
DateTimeRangeSelectorInput.propTypes = {
  inputIcon: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  hasError: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  size: _propTypes["default"].string.isRequired,
  isClearable: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool.isRequired,
  isValueSelected: _propTypes["default"].bool.isRequired,
  onClear: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired,
  popperAnchorRef: _propTypes["default"].func,
  setInputRef: _propTypes["default"].func,
  title: _propTypes["default"].string,
  id: _propTypes["default"].string,
  testId: _propTypes["default"].string
};
DateTimeRangeSelectorInput.defaultProps = {
  inputIcon: undefined,
  iconLeft: null,
  hasError: false,
  isClearable: false,
  isOpen: false,
  onClear: _lodash["default"],
  onClick: _lodash["default"],
  popperAnchorRef: _lodash["default"],
  setInputRef: _lodash["default"],
  title: '',
  id: undefined,
  testId: 'DATE_TIME_RANGE_SELECTOR_INPUT'
};
var _default = DateTimeRangeSelectorInput;
exports["default"] = _default;